<template>
  <div class="wf-fixed wf-w-full" :class="positionClasses">
    <div
      class="wf-relative"
      :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-4 wf-pb-2 wf-px-1' : ''"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <EditorOptions
        parent="component"
        v-show="hover && ! previewMode"
        :options="menuOptions"
      />
      <div class="wf-px-3 wf-py-2 wf-text-sm" :style="elementStyles(styles('styles'))" :class="elementClasses(classes('classes'), classes('customClasses'))">
        <div class="wf-flex wf-justify-between wf--mx-2 wf-h-10">
          <div class="wf-px-2 wf-flex wf-items-center" v-if="content.hasIcon">
            <div
              class="wf-w-10 wf-h-10 wf-flex wf-items-center wf-justify-center"
              :class="elementClasses(classes('iconContainerClasses'))"
              :style="elementStyles(styles('iconContainerStyles'))"
            >
              <i :style="elementStyles(styles('iconStyles'))" :class="[content.class, content.icon]"></i>
            </div>
          </div>
          <div class="wf-flex-1 wf-px-2 wf-flex wf-items-center">
            <div
              @keydown.enter.prevent
              contenteditable
              class="wf-w-full focus:wf-outline-none"
              v-text="content.text"
              @input="updateContentProperty('text', $event.target.textContent)"
            ></div>
          </div>
          <div class="wf-px-2 wf-flex wf-items-center" v-if="content.hasCTA">
            <div
              :class="elementClasses(classes('ctaClasses'))"
              :style="elementStyles(styles('ctaStyles'))"
              v-text="content.ctaText"
              @input="updateContentProperty('ctaText', $event.target.textContent)"
              contenteditable
              @keydown.enter.prevent
              class="wf-items-center wf-flex wf-justify-center wf-leading-none focus:wf-outline-none wf-font-bold wf-text-sm wf-tracking-wide wf-px-4 wf-h-10"
            ></div>
          </div>
          <div class="wf-px-2" v-if="content.isClosable">
            <div class="wf-h-10 wf-flex wf-items-center wf-justify-center wf-leading-none wf-w-5 wf-text-2xl">&times;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EditorPageComponent from '../contracts/EditorPageComponent'
  import ListensPropertyEvents from '../mixins/ListensPropertyEvents'
  export default EditorPageComponent.extend({
    mixins: [ListensPropertyEvents],
    computed: {
      positionClasses() {
        let positionClasses = this.classes('classes')[this.device].find(elementClass => elementClass.property == 'BannerPosition').value
        if(positionClasses == 'TOP') {
          return ['wf-top-0']
        }
        return ['wf-bottom-0']
      },
    },
  })
</script>